import { createAction, props } from '@ngrx/store';
import { Pagination } from 'src/app/shared/interfaces/pagination';
import { QueryParams } from 'src/app/shared/interfaces/query-params';
import { PaymentRun } from '../dto/pyament-run.dto';

export const loadPaymentRuns = createAction(
  '[PaymentRun] Load PaymentRuns',
  props<{
    data: {
      businessId: string;
      item: QueryParams;
    };
  }>()
);

export const loadPaymentRunsSuccess = createAction('[PaymentRun] Load PaymentRuns Success', props<{ data: Pagination<PaymentRun> }>());

export const loadPaymentRunsFailure = createAction('[PaymentRun] Load PaymentRuns Failure', props<{ error: Error | any }>());
